<mat-toolbar>
  Ayuda
</mat-toolbar>

<div class="pageContent helpPage">
  <mat-card class="helpCard">
    <div class="helpHeader">
      <img [src]="img" alt="Logo MITS Informática" class="helpLogo">
    </div>

    <h3 class="helpSectionTitle">Información de contacto</h3>

    <mat-nav-list class="helpList">
      <mat-list-item class="helpListItem">
        <mat-icon matListItemIcon class="helpIcon">call</mat-icon>
        <a matListItemTitle href="tel:+34934646120" class="helpLink">934 646 120</a>
        <a matListItemLine href="tel:+34661967095" class="helpLink">661 967 095</a>
      </mat-list-item>

      <mat-list-item class="helpListItem">
        <mat-icon matListItemIcon class="helpIcon">mail</mat-icon>
        <a matListItemTitle href="mailto:programacion@mitsinformatica.com" class="helpLink">programacion&#64;mitsinformatica.com</a>
        <a matListItemLine href="mailto:mits@mitsinformatica.com" class="helpLink">mits&#64;mitsinformatica.com</a>
      </mat-list-item>

      <a
        mat-list-item
        class="helpListItem helpListItem--address"
        href="https://www.google.es/maps/place/MITS+INFORMATICA+S.L./@41.445116,2.243814,15z/data=!4m2!3m1!1s0x0:0x7699bb99d2f8b836?sa=X&ved=2ahUKEwiqzYfE-s_sAhUR7eAKHS8oDo8Q_BIwDXoECBUQBQ"
        target="_blank"
        rel="noopener noreferrer">
        <mat-icon matListItemIcon class="helpIcon">business</mat-icon>
        <span matListItemTitle>Calle Conquista 69</span>
        <span matListItemLine>08912 Badalona (Barcelona, España)</span>
      </a>
    </mat-nav-list>

    <mat-divider></mat-divider>

    <div class="versionBlock">
      <div class="versionRow">
        <span>Versión actual</span>
        <strong>{{ appVersionNow }}</strong>
      </div>
      <div class="versionRow">
        <span>Última versión</span>
        <strong>{{ appVersionNew }}</strong>
      </div>
    </div>

    @if (displayUpdateButton) {
      <button mat-raised-button color="primary" class="updateButton" (click)="updateApp()">
        <mat-icon>upgrade</mat-icon>
        Actualizar
      </button>
    }

    @if (loadingBar) {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }
  </mat-card>
</div>
